import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/wedding-rsvp";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/wedding-rsvp")({
  head: SEO["/wedding-rsvp"],
  component: () => <ContentPage path="/wedding-rsvp" body={body} />,
});
